import {
  ApplicationQuestionFormCheckboxField,
  ApplicationQuestionFormCurrencyField,
  ApplicationQuestionFormDateField,
  ApplicationQuestionFormNumberField,
  ApplicationQuestionFormSelectField,
  ApplicationQuestionFormTextField,
  ApplicationQuestionFormToggleField,
  ApplicationQuestionLabel,
  ApplicationQuestionMultilineFormTextField,
} from './application-question-form-fields';

import { QuestionType } from '@converge/graphql';
import { SubmissionQuestionDetails } from './application-question';
import { handleError } from '@converge/utils';

interface RiskProfileApplicationQuestionSwitcherProps {
  question: SubmissionQuestionDetails;
  isApplicationViewOnly: boolean;
  onBlur?: () => void;
  onChange?: (key: string, value: unknown) => void;
}

const RiskProfileApplicationQuestionSwitcher = ({
  question,
  isApplicationViewOnly,
  onBlur,
  onChange,
}: RiskProfileApplicationQuestionSwitcherProps) => {
  const inner = (
    <>
      <RiskProfileApplicationQuestionSwitcherInner
        question={question}
        isApplicationViewOnly={isApplicationViewOnly}
        onBlur={onBlur}
        onChange={onChange}
      />
    </>
  );

  return <>{inner}</>;
};

interface RiskProfileApplicationQuestionSwitcherInnerProps {
  question: SubmissionQuestionDetails;
  isApplicationViewOnly: boolean;
  isGroupItem?: boolean;
  isSubGroupItem?: boolean;
  onBlur?: () => void;
  onChange?: (key: string, value: unknown) => void;
}

const RiskProfileApplicationQuestionSwitcherInner = ({
  question,
  isApplicationViewOnly,
  onBlur,
  onChange,
}: RiskProfileApplicationQuestionSwitcherInnerProps) => {
  switch (question.type) {
    case QuestionType.Label:
      return (
        <ApplicationQuestionLabel
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.String:
      return (
        <ApplicationQuestionFormTextField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.Float:
      return (
        <ApplicationQuestionFormNumberField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.Int:
      return (
        <ApplicationQuestionFormNumberField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.Currency:
      return (
        <ApplicationQuestionFormCurrencyField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.Bool:
      return (
        <ApplicationQuestionFormToggleField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.Option:
      return (
        <ApplicationQuestionFormCheckboxField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );

    case QuestionType.Multiline:
      return (
        <ApplicationQuestionMultilineFormTextField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.List:
      return (
        <ApplicationQuestionFormSelectField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case QuestionType.Date:
      return (
        <ApplicationQuestionFormDateField
          question={question}
          isDisabled={isApplicationViewOnly}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    // case QuestionType.Month:
    //   return (
    //     <ApplicationQuestionFormMonthField
    //       question={question}
    //       isDisabled={isApplicationViewOnly}
    //     />
    //   );
    default:
      handleError({
        message: `Unsupported question type: ${question.type}`,
        source: 'RiskProfileApplicationQuestionSwitcherInner',
        context: {
          data: {
            question,
          },
        },
      });
      return <>TODO: support "{question.type}"</>;
  }
};

export default RiskProfileApplicationQuestionSwitcher;
